module.exports = __webpack_public_path__ + "static/media/middle-east-bg-desktop.ec304272.png";